export const retouchMaskVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const retouchMaskFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

// Existing mask (we store mask in alpha channel)
uniform sampler2D u_texture0;

// Texture size in pixels
uniform vec2 u_size;

// Previous + current brush points in pixels (texture space)
uniform vec2 u_fromCoords;
uniform vec2 u_toCoords;

// Brush diameter in pixels
uniform float u_brushSize;

// 0..1 hardness (1 = hard edge, 0 = soft edge)
uniform float u_hardness;

out vec4 outColor;

float distanceToSegment(vec2 p, vec2 a, vec2 b) {
  vec2 ab = b - a;
  float denom = dot(ab, ab);
  // If points are the same, fallback to point distance.
  if (denom <= 1e-6) {
    return distance(p, a);
  }
  float t = clamp(dot(p - a, ab) / denom, 0.0, 1.0);
  vec2 c = a + ab * t;
  return distance(p, c);
}

void main() {
  float prevMask = texture(u_texture0, v_texCoord).a;

  vec2 pixel = u_size * v_texCoord; // 0.0 -> u_size
  float dist = distanceToSegment(pixel, u_fromCoords, u_toCoords);

  float radius = u_brushSize * 0.5;
  float inner = radius * clamp(u_hardness, 0.0, 1.0);
  float brushMask = 1.0 - smoothstep(inner, radius, dist); // 1 at center, 0 at edge

  float nextMask = max(prevMask, brushMask);

  // Store mask in alpha channel; RGB kept black for preview overlays.
  outColor = vec4(0.0, 0.0, 0.0, nextMask);
}
` as const;
